import React from 'react';
import {
    LayoutPanelTop,
    MemoryStick,
    SquareFunction,
    NotebookPen,
    Wallet,
    BookCopy,
    FileText,
} from 'lucide-react';
import { DisplaySettings } from '@mui/icons-material';

const ProgressTab = ({ chatId, selectedCollection, selectedEnvironment, collections, environments, handleOpenTab, generatedTestScenarios }) => {
    const configItems = [
        environments?.find(e => e.id === selectedEnvironment) && {
            icon: <DisplaySettings fontSize='small' size={16} className="text-emerald-400" />,
            title: environments.find(e => e.id === selectedEnvironment).title,
            subtitle: 'Environment',
            type: 'environment',
            id: selectedEnvironment,
            color: 'emerald',
        },
        {
            icon: <MemoryStick size={16} className="text-indigo-400" />,
            title: "Memory",
            subtitle: 'Default',
            type: 'memory',
            id: "memory",
            color: 'indigo',
        },
        {
            icon: <SquareFunction size={16} className="text-emerald-400" />,
            title: "Function",
            subtitle: 'JS Functions',
            type: 'function',
            id: "function",
            color: 'emerald',
        },
        {
            icon: <NotebookPen size={16} className="text-amber-400" />,
            title: "Build",
            subtitle: 'Reports',
            type: 'build-reports',
            id: "build-reports",
            color: 'amber',
        },
        {
            icon: <Wallet size={16} className="text-rose-400" />,
            title: "Transactions",
            subtitle: "Check Tokens",
            type: 'transactions',
            id: "transactions",
            color: 'rose',
        },
        selectedCollection?.length > 0 && {
            icon: <BookCopy size={16} className="text-indigo-400" />,
            title: collections?.find(c => c.id === selectedCollection[0])?.name || "Collection",
            subtitle: "Swagger Doc",
            type: "collection-swagger",
            id: selectedCollection[0],
            color: 'indigo',
        },
        generatedTestScenarios?.length > 0 && {
            icon: <FileText size={16} className="text-blue-400" />,
            title: "Generated Test Scenarios",
            subtitle: `${generatedTestScenarios.length} Scenarios Generated`,
            type: 'generated-test-scenarios',
            id: "generated-test-scenarios",
            color: 'blue',
        }
    ].filter(Boolean);

    const getHoverStyles = (color) => {
        const styles = {
            blue: 'group-hover:bg-blue-400/10 group-hover:text-blue-400',
            emerald: 'group-hover:bg-emerald-400/10 group-hover:text-emerald-400',
            purple: 'group-hover:bg-purple-400/10 group-hover:text-purple-400',
            indigo: 'group-hover:bg-indigo-400/10 group-hover:text-indigo-400',
            sky: 'group-hover:bg-sky-400/10 group-hover:text-sky-400',
            amber: 'group-hover:bg-amber-400/10 group-hover:text-amber-400',
            rose: 'group-hover:bg-rose-400/10 group-hover:text-rose-400'
        };
        return styles[color] || styles.blue;
    };

    return (
        <div className="w-full flex flex-col h-full">
            <div className="w-full flex-1 overflow-y-auto px-4 py-6 chatscreen-custom-scrollbar">
                <div className="w-full space-y-6">
                    {/* Active Configuration Card */}
                    {chatId && (
                        <div className="bg-[var(--agent-prompt)] rounded-xl p-3 backdrop-blur-sm">
                            <div className="grid grid-cols-1 md:grid-cols-2 items-center mb-4">
                                {/* Left Section */}
                                <div className="flex items-center gap-2">
                                    <LayoutPanelTop size={18} className="text-[var(--primary-color)]" />
                                    <span className="fs18 font-medium text-[var(--text-primary)]">Active Configuration</span>
                                </div>

                                {/* Right Section */}
                                <div className="text-right">
                                    <span className="fs15">ID: {chatId}</span>
                                </div>
                            </div>
                            <div className="overflow-x-auto pb-2 -mx-1">
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 px-1">
                                    {configItems.map((item, index) => (
                                        <div
                                            key={index}
                                            className="relative group cursor-pointer"
                                            onClick={() => handleOpenTab(item, item.type)}
                                        >
                                            <div
                                                className={`relative flex items-center justify-between p-2 bg-[var(--hover-bg)] rounded-lg transition-colors duration-200 ${getHoverStyles()}`}
                                            >
                                                {/* Left side: Icon and Text */}
                                                <div className="flex items-center gap-3">
                                                    <div
                                                        className={`px-2 py-1 rounded-md bgSecondary transition-colors duration-200 
                                                        ${getHoverStyles()}`}
                                                    >
                                                        {item.icon}
                                                    </div>
                                                    <div>
                                                        <div className="fs14 text-[var(--text-primary)] font-normal line-clamp-1">
                                                            {item.title}
                                                        </div>
                                                        <div className="fs12 text-[var(--text-secondary)]">
                                                            {item.subtitle}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div >
    );
};

export default ProgressTab;
